import { getAxiosClient } from '@/helpers/auth';
import type { AxiosInstance } from 'axios';

let cachedClient: AxiosInstance | null = null;

export async function getSafeAxiosClient (): Promise<AxiosInstance> {
  if (cachedClient) return cachedClient;
  const client = await getAxiosClient();
  if (!client) throw new Error('API-klient ikke initialisert');
  cachedClient = client;
  return client;
}
